import Vue from "vue";

const that = Vue.prototype;
const requiredField = v => !!v || that.$t("REQUIRED_FIELD");
const governmentCode = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "31",
  "32",
  "33",
  "34",
  "35",
  "88"
]; // 88 مولود خاج مصر
const monthThirtyOneDay = ["01", "03", "05", "07", "08", "10", "12"];
const monthThirtyDay = ["04", "06", "09", "11"];
const arField = v =>
  (v && /^[\u0621-\u064A ]+$/.test(v.trim())) || that.$t("ARABIC_FIELD");
const enField = v =>
  (v && /^[A-Za-z ]+$/.test(v.trim())) || that.$t("ENGLISH_FIELD");

function isNotEmpty(str) {
  return !(!str || 0 === str.length || /^\s*$/.test(str));
}

export default {
  state: {
    required: requiredField,
    arField: arField,
    enField: enField,
    numberField: v => /^[0-9\b]+$/.test(v) || that.$t("NUMBER_FIELD"),
    fileField: v => !v || v.size < 5000000 || that.$t("IMAGE_SIZE_VALIDATION"),
    NIDRulse: [
      requiredField,
      v =>
        isNotEmpty(v)
          ? (v !== undefined &&
              v.slice(3, 5) <= "12" &&
              v.slice(5, 7) > "00" &&
              v.slice(5, 7) <= "31" &&
              governmentCode.includes(v.slice(7, 9)) &&
              v.slice(12, 13) >= "0" &&
              /^(2|3)[0-9]{13}/.test(v)) ||
            that.$t("NID_VALIDATION")
          : true,
      v =>
        isNotEmpty(v)
          ? v !== undefined &&
            ((v.slice(3, 5) === "02" && v.slice(5, 7) <= "29") ||
              (monthThirtyOneDay.includes(v.slice(3, 5)) &&
                v.slice(5, 7) <= "31") ||
              (monthThirtyDay.includes(v.slice(3, 5)) &&
                v.slice(5, 7) <= "30") ||
              that.$t("NID_VALIDATION"))
          : true,
          function (v) {
             if (v != "" && v) {
                let { day, month, year } = "";
                day = v.slice(5, 7);
                month = v.slice(3, 5);
                if (v.slice(0, 1) === "2") {
                  year = "19" + v.slice(1, 3);
                } else {
                  year = "20" + v.slice(1, 3);
                }
                const dob = year + "-" + month + "-" + day;
                return new Date(dob).toISOString() <= new Date().toISOString() || that.$t("FUTURE_DATE")
             } else {
                return ""
             }
          }
    ],
    passportRulse: [
      requiredField,
      v => /^[a-zA-Z0-9]{0,}$/.test(v) || that.$t("PASSPORT_VALIDATION"),
      v => (v && (v || "").trim().length >= 5) || that.$t("MIN_FIELD") + "5",
      v => (v && (v || "").trim().length <= 25) || that.$t("MAX_FIELD") + "25"
    ],
    emailRules: [
      requiredField,
      v =>
        /^[A-Za-z0-9._%-]{1,64}@[A-Za-z0-9._%-]{1,251}\.[a-z]{2,3}$/.test(v) ||
        that.$t("EMAIL_VALIDATION")
    ],
    passwordRulse: [
      requiredField,
      v =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/.test(v) ||
        that.$t("PASSWORD_VALIDATION"),
      v => (v != undefined && v.length > 5) || that.$t("MIN_FIELD") + "6"
    ],
    requiredRule: [v => isNotEmpty(v) || that.$t("REQUIRED_FIELD")],
    nonRequiredRule: [() => true],
    arNameRules: [
      v => isNotEmpty(v) || that.$t("REQUIRED_FIELD"),
      arField,
      v => (v && (v || "").trim().length > 9) || that.$t("MIN_FIELD") + "10"
    ],
    enNameRules: [
      v => isNotEmpty(v) || that.$t("REQUIRED_FIELD"),
      enField,
      v => (v && (v || "").trim().length > 9) || that.$t("MIN_FIELD") + "10"
    ],
    // Must be used as a computed prop
    divisionTypeRule: certificateType => [
      v => {
        if ([15, 17].includes(certificateType)) {
          return [18, 19].includes(v) || that.$t("REQUIRED_FIELD");
        } else if (certificateType === 16) {
          return [19, 20, 21].includes(v) || that.$t("REQUIRED_FIELD");
        } else {
          return [18, 19, 20, 21].includes(v) || that.$t("REQUIRED_FIELD");
        }
      }
    ],
    // Must be used as a computed prop
    dOBRules: cardType => [
      v => {
        if (cardType === 2) {
          return isNotEmpty(v) || that.$t("REQUIRED_FIELD");
        } else {
          return true;
        }
      },
      v =>
        isNotEmpty(v)
          ? new Date(v).toISOString() <= new Date().toISOString() ||
            that.$t("FUTURE_DATE")
          : true,
      v => {
        let today = new Date();
        let birthDate = new Date(v);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }

        return isNotEmpty(v)
          ? (14 <= age && age <= 31) || that.$t("VALID_DATE_RANGE")
          : true;
      }
    ],
    phoneRules: [
      v => isNotEmpty(v) || that.$t("REQUIRED_FIELD"),
      v => (isNotEmpty(v) ? /^\d+$/.test(v) || that.$t("NUMBER_FIELD") : true),
      v => (v && v.length <= 20) || that.$t("MAX_FIELD") + "20"
    ],
    refNumRules: [
      v => isNotEmpty(v) || that.$t("REQUIRED_FIELD"),
      v => (isNotEmpty(v) ? /^\d+$/.test(v) || that.$t("NUMBER_FIELD") : true),
      v => (v && v.length <= 30) || that.$t("MAX_FIELD") + "30"
    ],
    photoRules: [
      v => {
        if (!!v && v instanceof File) {
          const extensions = /(\.apng|\.bmp|\.gif|\.jpg|\.jpeg|\.jfif|\.pjpeg|\.pjp|\.png|\.webp)$/i;
          return !(v.size / 1000000 <= 5)
            ? that.$t("IMAGE_SIZE_VALIDATION")
            : !extensions.test(v.name)
            ? that.$t("IMAGE_EXTENTION_VALIDATION")
            : true;
        }
        return true;
      }
    ],
    pdfRules:[
        value=> {
       if (!value) return that.$t("REQUIRED_FIELD");
       if (value.type !== 'application/pdf') return that.$t("PDF_EXTENTION_VALIDATION");
       return true;
      }
    ],
    // Must be used as a computed prop
    totalRules: (preQualYear, currentYearId) => [
      v =>
        preQualYear !== currentYearId
          ? isNotEmpty(v) || that.$t("REQUIRED_FIELD")
          : true,
      v =>
        isNotEmpty(v)
          ? /^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(v) || that.$t("NUMBER_FIELD")
          : true,
      v =>
        isNotEmpty(v)
          ? parseFloat(v) <= 9999 || that.$t("UserData.CERTIFICATE_RESULT_MAX")
          : true
    ],
    // Must be used as a computed prop
    otherCertificateRules: foreignCertificate => [
      v =>
        foreignCertificate === 32
          ? isNotEmpty(v) || that.$t("REQUIRED_FIELD")
          : true,
      v =>
        isNotEmpty(v)
          ? /^[a-zA-Z0-9 \u0621-\u064A]*$/.test(v) ||
            that.$t("ALPHA_NUMERIC_FIELD")
          : true
    ]
  },
  mutations: {},
  actions: {},
  getters: {}
};
